import React from 'react';
import Button from '../ui/Button';
import styles from '../../pages/Login.module.css';
import ssoStyles from './SsoButtons.module.css';

const GoogleIcon = () => (
    <svg
        aria-hidden="true"
        width="18"
        height="18"
        viewBox="0 0 48 48"
    >
        <path
            fill="#EA4335"
            d="M24 9.5c3.54 0 6 1.54 7.38 2.83l5.42-5.42C33.89 3.36 29.47 1.5 24 1.5 14.92 1.5 7.16 6.64 3.44 14.01l6.68 5.19C11.83 13.59 17.34 9.5 24 9.5z"
        />
        <path
            fill="#34A853"
            d="M46.08 24.55c0-1.46-.13-2.53-.41-3.64H24v7.08h12.65c-.56 3.54-2.87 6.14-6.16 8.03l6.01 4.66c3.7-3.42 5.58-8.46 5.58-16.13z"
        />
        <path
            fill="#FBBC05"
            d="M10.12 28.8A14.5 14.5 0 0 1 9.5 24c0-1.67.29-3.29.79-4.8l-6.85-5.19C1.65 16.98 0.5 20.35 0.5 24c0 3.65 1.15 7.02 3 9.99z"
        />
        <path
            fill="#4285F4"
            d="M24 46.5c5.47 0 10.07-1.8 13.42-4.88l-6.01-4.66c-1.67.99-3.93 1.69-7.41 1.69-6.66 0-12.16-4.09-14.14-9.71l-6.68 5.19C7.16 41.36 14.92 46.5 24 46.5z"
        />
    </svg>
);

const MicrosoftIcon = () => (
    <svg
        aria-hidden="true"
        width="18"
        height="18"
        viewBox="0 0 24 24"
    >
        <rect x="3" y="3" width="8" height="8" fill="#F35325" />
        <rect x="13" y="3" width="8" height="8" fill="#81BC06" />
        <rect x="3" y="13" width="8" height="8" fill="#05A6F0" />
        <rect x="13" y="13" width="8" height="8" fill="#FFBA08" />
    </svg>
);

const SsoButtons = ({ disabled = false, onGoogle, onMicrosoft, dividerLabel = 'or continue with' }) => {
    return (
        <div className={styles.ssoBlock}>
            
            <div className={styles.ssoButtonsRow}>
                <Button
                    type="button"
                    variant="ghost"
                    className={styles.ssoButton}
                    disabled={disabled}
                    onClick={onGoogle}
                    icon={<GoogleIcon />}
                >
                    Google
                </Button>
                <div className={ssoStyles.comingSoonWrap}>
                    <Button
                        type="button"
                        variant="ghost"
                        className={styles.ssoButton}
                        disabled
                        icon={<MicrosoftIcon />}
                        aria-label="Microsoft sign-in — coming soon"
                    >
                        Microsoft
                    </Button>
                    <span className={ssoStyles.comingSoonBadge} aria-hidden>Coming soon</span>
                </div>
            </div>
            <div className={styles.ssoDivider} style={{ marginTop: '20px' , marginBottom: '20px' }}>
                <span className={styles.ssoDividerLine} />
                <span className={styles.ssoDividerLabel}>OR</span>
                <span className={styles.ssoDividerLine} />
            </div>
        </div>
    );
};

export default SsoButtons;

